
import MHeader from '../Header/Header.vue';
import Api from '@/utils/api';
import Divider from 'vux/src/components/divider/index.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'

export default {
components: {
MHeader,
Divider,
Timeline,
TimelineItem
},
data() {
return {
loading: true,
nodata: false,
expressInfosData: []
}
},
created() {
this.loading = true
this.nodata = false
Api.orderExpressInfo(this.$route.params.tid)
.then(resp => {
this.loading = false
if (resp.data) {
this.expressInfosData = resp.data
console.log(this.expressInfosData)
} else {
this.nodata = true
}
})
.catch((e) => {
this.loading = false
this.nodata = true
})
}
}



// WEBPACK FOOTER //
// ./src/components/OrderList/CourierInfo.vue